import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '../constants';
import { IPagedResults } from '../core/interfaces';
import { BaseDataService, DataService } from '../core/services';

@Injectable()
export class ActivityService extends BaseDataService {
    constructor(protected dataService: DataService) {
        super(dataService, API_URL);
    }

    public getAllTask(accountId: number, searchText: string, isPublished = null, siteId = null, showArchived = false): Observable<IPagedResults<any>> {
        let url = `Task/GetAll?accountId=${accountId}&searchText=${searchText}&showArchived=${showArchived}
                        ${(isPublished != null ? `&isPublished=${isPublished}`: '')}
                        ${(siteId != null ? `&siteId=${siteId}`: '')}`;
        return super.getAll<any>(url);
    }

    public DownloadReport(taskId) {
        let url = `Task/DownloadTask?taskId=${taskId}`;

        return super.savePDF<any>(url, 'application/pdf');
    }
    public DownloadReportActivityList(accountId) {
        let url = `Task/DownloadActivity?accountId=${accountId}`;

        return super.savePDF<any>(url, 'application/pdf');
    }
    public GetAllMainCategory(id: number): Observable<any> {
        let url = `Task/GetAllMainCategory?id=${id}`;
        return super.getAll<any>(url);
    }

    public GetSubCategory(id: number): Observable<any> {
        let url = `Task/GetSubCategory?id=${id}`;
        return super.getAll<any>(url);
    }

    public GetActivityRole(id: number): Observable<any> {
        let url = `Task/GetActivityRole?id=${id}`;
        return super.getAll<any>(url);
    }

    public getAllMainCategories(accountId: number): Observable<IPagedResults<any>> {
        let url = `Task/GetAllMainCategories?accountId=${accountId}`;
        return super.getAll<any>(url);
    }

    public getByUserId(id: number): Observable<any> {
        let url = `Task/GetByUserId?id=${id}`;
        return super.getAll<any>(url);
    }

    public getAllSubCategories(accountId: number): Observable<IPagedResults<any>> {
        let url = `Task/GetAllSubCategories?accountId=${accountId}`;
        return super.getAll<any>(url);
    }

    public getAllActivityRoles(accountId: number): Observable<IPagedResults<any>> {
        let url = `Task/GetAllActivityRoles?accountId=${accountId}`;
        return super.getAll<any>(url);
    }

    public getTask(id?: number): Observable<any> {
        let url = `Task/Get?id=${id}`;
        return super.getAll<any>(url);
    }

    public saveTask(data) {
        let url = `Task/Save`;
        return super.save<any>(url, data);
    }

    public transfer(data) {
        let url = `Task/Transfer`;
        return super.save<any>(url, data);
    }

    public deleteTask(data) {
        let url = `Task/Delete?id=${data}`;
        return super.save<any>(url, data);
    }

    public DeleteSiteTaskLog(data) {
        let url = `Task/DeleteSiteTaskLog?id=${data}`;
        return super.save<any>(url, data);
    }

    public deleteMainCategory(data) {
        let url = `Task/DeleteMainCategory?id=${data}`;
        return super.save<any>(url, data);
    }
    public deleteInterval(data) {
        let url = `Task/DeleteInterval?id=${data}`;
        return super.save<any>(url, data);
    }
    public deleteSubCategory(data) {
        let url = `Task/DeleteSubCategory?id=${data}`;
        return super.save<any>(url, data);
    }

    public deleteActivityRole(data) {
        let url = `Task/DeleteActivityRole?id=${data}`;
        return super.save<any>(url, data);
    }

    public archiveTask(data) {
        let url = `Task/ArchiveTask?id=${data}`;
        return super.save<any>(url, data);
    }
    public unarchiveTask(data) {
        let url = `Task/UnarchiveTask?id=${data}`;
        return super.save<any>(url, data);
    }

    public SaveSubCategory(data) {
        let url = `Task/SaveSubCategory`;
        return super.save<any>(url, data);
    }
    public SaveMainCategory(data) {
        let url = `Task/SaveMainCategory`;
        return super.save<any>(url, data);
    }
    public SaveActivityRole(data) {
        let url = `Task/SaveActivityRole`;
        return super.save<any>(url, data);
    }

    public publishTask(data) {
        let url = `Task/PublishTask`;
        return super.save<any>(url, data);
    }

    public unpublishTask(data) {
        let url = `Task/UnPublishTask`;
        return super.save<any>(url, data);
    }

    public getPublishedTask(id: number): Observable<IPagedResults<any>> {
        let url = `Task/GetPublishedTask?id=${id}`;
        return super.getAll<any>(url);
    }

    public getAllTaskBySiteId(siteId: number, userId: number, searchValue: string, accountId: number = 0): Observable<IPagedResults<any>> {
        let url = `Task/GetAllBySiteId?siteId=${siteId}&userId=${userId}&searchValue=${searchValue}&accountId=${accountId}`;
        return super.getAll<any>(url);
    }

    public GetXls(siteId: number, userId: number, searchValue: string) {
        let url = `Task/GetExcelBySiteId?siteId=${siteId}&userId=${userId}&searchValue=${searchValue}`;

        return super.savePDF<any>(url, 'application/pdf');
    }

    public GetXlsAllTask(accountId: number, searchText: string, isPublished = null, siteId = null, showArchived = false): Observable<IPagedResults<any>> {
        let url = `Task/GetXlsAllTask?accountId=${accountId}&searchText=${searchText}&showArchived=${showArchived}
        ${(isPublished != null ? `&isPublished=${isPublished}`: '')}
        ${(siteId != null ? `&siteId=${siteId}`: '')}`;
        return super.savePDF<any>(url, 'application/pdf');
    }

    public getTaskBySiteIdAndTaskId(taskId?: number, siteId?: number): Observable<any> {
        let url = `Task/GetTaskBySiteIdAndTaskId?taskId=${taskId}&siteId=${siteId}`;
        return super.getAll<any>(url);
    }
    public getHistory(siteTaskId: number): Observable<any> {
        let url = `Task/GetHistory?siteTaskId=${siteTaskId}`;
        return super.getAll<any>(url);
    }

    public getSingleHistory(id: number): Observable<any> {
        let url = `Task/GetSingleHistory?id=${id}`;
        return super.getAll<any>(url);
    }

    public confirm(data) {
        let url = `Task/Confirm`;
        return super.save<any>(url, data);
    }


    public reAssign(data) {
        let url = `Task/ReAssign`;
        return super.save<any>(url, data);
    }

    public confirmMultiple(data) {
        let url = `Task/ConfirmMultiple`;
        return super.save<any>(url, data);
    }

    public performAction(data) {
        let url = `Task/PerformAction`;
        return super.save<any>(url, data);
    }

    public performUpload(data) {
        let url = `Task/UploadFiles`;
        return super.save<any>(url, data);
    }

    public SaveInterval(data) {
        let url = `Task/SaveInterval`;
        return super.save<any>(url, data);
    }

    public GetInterval(id: number): Observable<any> {
        let url = `Task/GetInterval?id=${id}`;
        return super.getAll<any>(url);
    }

    public GetIntervals(accountId: number): Observable<any> {
        let url = `Task/GetIntervals?accountId=${accountId}`;
        return super.getAll<any>(url);
    }

    public getEmailLogs(accountId: number, siteId: number, reportType: string ) {
        let url = `Task/Logs?accountId=${accountId}&siteId=${siteId}&reportType=${reportType}`;
        return super.getAll<any>(url);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/activity.service.ts